declare let require:any;
let context:any;
let library:any;

try {
    context = require.context("./", true, /(?<!test)\.tsx?$/);
    library = {};
    for (let key of context.keys()) {
        library[key.substring(0, key.lastIndexOf('.'))] = key;
    }
}catch(E)
{

}

export default function  (libraryName) {

    libraryName='./'+libraryName.substring(14);//removed /InternalShared and adding ./

    if(library[libraryName]==null)
        throw 'Library not found '+libraryName;

    return context(library[libraryName]);


}